var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGxt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9925 19.4927C36.4878 15.9652 35.8959 12.2798 34.104 9.17652C33.5237 8.16855 32.8263 7.23177 32.0262 6.3854C31.1182 5.43102 30.0813 4.58468 29.0928 3.72034C31.8058 6.15555 33.555 9.47321 34.0255 13.0761C34.4846 16.7142 33.8233 20.4052 32.1289 23.6623C30.479 26.8707 27.9969 29.5832 24.9392 31.5195C21.896 33.4589 18.3419 34.4568 14.7274 34.3866C11.4251 34.3109 8.23617 33.1752 5.6371 31.1493C5.44382 30.9946 5.25457 30.8365 5.06934 30.6751C6.37198 31.8236 7.63033 33.0401 9.12223 33.9484C10.4922 34.7804 11.9877 35.3884 13.5516 35.7492C17.0106 36.5495 20.6809 36.1493 23.9526 34.8108C27.2299 33.4518 30.0839 31.2502 32.2215 28.4322C34.2221 25.819 35.5199 22.7424 35.9925 19.4927Z",
    fill: "url(#paint0_linear_173_11235)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M23.959 34.8138C25.0991 34.3439 26.1919 33.7678 27.2226 33.0931L25.9723 31.7766C25.8234 31.8766 25.6724 31.9766 25.5193 32.0727C22.4159 34.0516 18.7909 35.0697 15.1042 34.9978C12.4931 34.9272 9.9398 34.2173 7.6709 32.931C9.38854 34.3052 11.4016 35.2678 13.5539 35.7441C17.0209 36.5425 20.6913 36.1503 23.959 34.8138Z",
    fill: "url(#paint1_linear_173_11235)",
    fillOpacity: 0.5
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6587 0.089869C29.884 1.05426 35.7589 9.49364 33.7858 18.9434C31.8128 28.3932 22.7325 35.27 13.5073 34.3076C4.28207 33.3452 -1.59292 24.9038 0.382189 15.454C2.3573 6.00424 11.4355 -0.872516 20.6587 0.089869Z",
    fill: "url(#paint2_linear_173_11235)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M20.5361 0.485093C11.633 -0.445279 2.87089 6.20138 0.964234 15.315C0.819799 16.0052 0.717601 16.7034 0.658203 17.4059C4.57968 20.1903 9.16808 21.9027 13.9645 22.3719C20.7274 23.0781 27.454 21.4755 33.2928 18.1902C34.9034 9.27061 29.2781 1.39946 20.5361 0.485093Z",
    fill: "url(#paint3_linear_173_11235)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9135 33.4957C6.69098 32.6353 0.697205 25.5145 2.54346 16.677C4.38971 7.83942 12.8861 1.40084 21.5093 2.3052C28.7574 3.0615 32.9855 9.12993 33.3116 15.8326C33.67 7.85742 28.2661 1.18675 20.2469 0.350417C11.3157 -0.583957 2.52131 6.07871 0.60459 15.2304C-1.31213 24.382 4.38367 32.5553 13.3169 33.4877C14.1194 33.5716 14.927 33.5951 15.733 33.5577C15.4672 33.5437 15.1894 33.5237 14.9135 33.4957Z",
    fill: "#94512A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3278 1.92931C19.8483 1.92993 20.3684 1.95664 20.8862 2.00934C24.7337 2.4095 28.0678 4.28625 30.2725 7.28745C31.4267 8.86323 32.226 10.6675 32.616 12.5776C33.0393 14.6628 33.0256 16.8124 32.5758 18.8921C31.7223 22.8503 29.5502 26.4067 26.4108 28.9861C23.276 31.5772 19.4668 33.0138 15.6776 33.0138C15.1572 33.0132 14.637 32.9865 14.1193 32.9337C10.2718 32.5336 6.93763 30.6568 4.733 27.6556C3.57978 26.0797 2.78183 24.2754 2.39347 22.3655C1.96945 20.2804 1.98247 18.1308 2.43173 16.051C3.28308 12.0891 5.45532 8.52892 8.59664 5.94692C11.7254 3.35588 15.5347 1.92931 19.3278 1.92931ZM19.3278 0.454718C10.8194 0.454718 2.81829 6.98133 0.986134 15.7408C-0.966826 25.0866 4.84575 32.6856 13.9703 33.64C14.5395 33.6992 15.1114 33.7286 15.6837 33.728C24.1921 33.728 31.5087 27.4635 33.3388 18.704C35.2918 9.35828 30.1678 1.49714 21.0432 0.542754C20.4734 0.483598 19.9008 0.454212 19.3278 0.454718Z",
    fill: "#E99855"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9261 1.4906C19.452 1.49088 19.9775 1.51826 20.5006 1.57263C24.3904 1.97279 27.7608 3.87355 29.9916 6.90877C31.1568 8.5021 31.963 10.3262 32.3552 12.2569C32.7836 14.3645 32.7699 16.5373 32.315 18.6395C31.4524 22.6407 29.257 26.2359 26.0836 28.8436C22.9206 31.4626 19.0691 32.9052 15.2397 32.9052C14.7131 32.9049 14.1869 32.8775 13.6632 32.8231C9.77339 32.423 6.40302 30.5222 4.17423 27.487C3.01041 25.8938 2.20498 24.0706 1.81256 22.1409C1.3842 20.0326 1.3979 17.8591 1.85283 15.7563C2.71983 11.7544 4.91862 8.15961 8.09425 5.55222C11.2452 2.93317 15.1007 1.4906 18.9261 1.4906ZM18.9261 -1.77873e-09C10.3251 -9.70334e-10 2.23335 6.60264 0.383076 15.4542C-1.59203 24.902 4.28497 33.3434 13.5082 34.3077C14.084 34.3676 14.6627 34.3976 15.2417 34.3978C23.8448 34.3978 31.9344 27.7951 33.7867 18.9436C35.7598 9.4938 29.8848 1.05442 20.6596 0.0900361C20.0838 0.0302176 19.5051 0.000165119 18.9261 -1.77873e-09V-1.77873e-09Z",
    fill: "url(#paint4_linear_173_11235)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.6108 0.0900361C20.0349 0.0302176 19.4563 0.000165119 18.8773 -1.77423e-09C10.2681 -9.65076e-10 2.1845 6.60264 0.334218 15.4542C0.170998 16.2351 0.0593536 17.0258 1.67497e-09 17.8211C0.473811 18.1519 0.959031 18.4681 1.45566 18.7695C1.48077 17.7563 1.60007 16.7477 1.81202 15.7563C2.67903 11.7544 4.87782 8.15961 8.05344 5.55222C11.1963 2.93317 15.0479 1.4906 18.8793 1.4906C19.4052 1.49088 19.9307 1.51826 20.4537 1.57263C24.3435 1.97279 27.7139 3.87355 29.9447 6.90877C31.1099 8.5021 31.9161 10.3262 32.3084 12.2569C32.7368 14.3645 32.7231 16.5373 32.2681 18.6395C32.2299 18.8195 32.1876 18.9976 32.1433 19.1757C32.7245 18.8822 33.299 18.5721 33.8667 18.2453C35.419 9.08164 29.6085 1.03041 20.6108 0.0900361Z",
    fill: "url(#paint5_linear_173_11235)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6726 9.19287L21.1747 13.8067L13.0488 13.8587L13.0488 22.5322L21.8291 22.5322L21.8291 19.7951L18.5634 19.7951L15.03 15.4494L26.5766 15.4494L26.5987 22.5362L23.0653 26.0476L11.8791 26.0476L8.2832 22.4822L8.2832 13.9168L11.7321 9.19287L25.6726 9.19287Z",
    fill: "#94512A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0719 9.78882L21.774 13.2062L12.3857 13.2502L12.3857 21.9237L21.1659 21.9237L21.1659 19.1906L17.9003 19.1906L14.1293 15.4491L25.9718 15.4491L25.9316 21.9317L22.3981 25.4431L11.2079 25.4431L7.62207 21.8777L7.62207 13.3122L10.8314 9.78882L25.0719 9.78882Z",
    fill: "url(#paint6_linear_173_11235)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7453 9.15051L22.238 12.6619L11.6377 12.6619L11.6377 21.3334L20.418 21.3334L20.418 18.5923L17.1523 18.5923L13.9309 15.391L25.1735 15.391L25.1735 21.3234L21.6401 24.8348L10.4699 24.8348L6.87207 21.2794L6.87207 12.7139L10.4699 9.15051L25.7453 9.15051Z",
    fill: "url(#paint7_linear_173_11235)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9921 22.5694C13.0096 22.5694 9.40772 21.629 6.8125 20.1144L6.8125 21.409L10.3983 24.9724L21.5886 24.9724L25.122 21.463L25.122 21.1148C22.5286 22.1049 19.7701 22.5985 16.9921 22.5694Z",
    fill: "url(#paint8_linear_173_11235)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_11235",
    x1: 39.528,
    y1: -13.2405,
    x2: 9.68147,
    y2: 49.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD571B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_11235",
    x1: 21.7544,
    y1: 24.0955,
    x2: 14.0436,
    y2: 40.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E08C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD06F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_11235",
    x1: 7.69069,
    y1: 63.9675,
    x2: 28.1443,
    y2: -39.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D85D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_173_11235",
    x1: 12.0196,
    y1: 42.2098,
    x2: 25.3875,
    y2: -25.2013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0863C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD06F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_173_11235",
    x1: 23.8589,
    y1: -9.34774,
    x2: 6.35047,
    y2: 60.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFD23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_173_11235",
    x1: 22.9362,
    y1: -6.05442,
    x2: 11.5346,
    y2: 39.1837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFFFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFEB6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_173_11235",
    x1: 7.62207,
    y1: 17.616,
    x2: 25.9718,
    y2: 17.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFD067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CD553F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_173_11235",
    x1: 6.87207,
    y1: 16.9977,
    x2: 25.7453,
    y2: 16.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFFFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFEB6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_173_11235",
    x1: 6.8125,
    y1: 22.5394,
    x2: 25.122,
    y2: 22.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFDA42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGxt);
export default __webpack_public_path__ + "static/media/gxt.8f81a5cd73ab88354242ea2fab8109da.svg";
export { ForwardRef as ReactComponent };